__turbopack_context__.v({
  "className": "oswald_b19551f7-module__qSM5pq__className",
  "variable": "oswald_b19551f7-module__qSM5pq__variable",
});
